module.exports = __webpack_public_path__ + "img/ai_chat_mode.da4d001.png";